module.exports = __webpack_public_path__ + "img/building95-2.7ba0f2a1.jpg";